var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "margin": "50px 0"
    }
  }, [_c('v-row', {
    staticClass: "mypage-contents__head"
  }, [_c('v-col', {
    staticClass: "mypage-contents__title",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v(" 신청내역 ")]), _c('v-spacer'), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    attrs: {
      "cols": "auto"
    }
  }, [_vm.disabled ? _c('v-btn', {
    attrs: {
      "outlined": "",
      "color": _vm.disabled ? 'primary' : 'gray'
    },
    on: {
      "click": function click($event) {
        _vm.disabled = !_vm.disabled;
      }
    }
  }, [_vm._v("수정하기")]) : _vm._e()], 1)], 1), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticClass: "board-table board-table--input",
    attrs: {
      "role": "table"
    }
  }, [_c('view-application-support', {
    attrs: {
      "files": _vm.files,
      "program": _vm.program
    },
    on: {
      "files": _vm.syncFiles
    },
    model: {
      value: _vm.applicant,
      callback: function callback($$v) {
        _vm.applicant = $$v;
      },
      expression: "applicant"
    }
  })], 1)]), !_vm.disabled ? _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "gray"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("수정")])], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }